module.exports = __webpack_public_path__ + "static/media/icon_nightNormal.278352f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_nightNormal.svg
// module id = 2418
// module chunks = 7